import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import PaymentForm from "./PaymentForm";
// import "./App.css";
import { useRecoilValue } from "recoil";
import { containerOne } from "../utils/style";
// Recoil Atoms Import
import paymentDetailAtom from "../atoms/paymentDetailAtom";
import { useNavigate } from "react-router-dom";
import arrowBlack from '../assets/icons/arrow_black.png';
import { stripePublicKey } from '../utils/config';

// Make sure to call loadStripe outside of a component's render
const stripePromise = loadStripe(stripePublicKey);

export default function App() {
  const navigate = useNavigate();
  const paymentDetail = useRecoilValue(paymentDetailAtom);

  console.log(paymentDetail);

  const appearance = {
    theme: 'stripe',
    variables: {
      colorBackground: '#F0F4F8'
    },
    rules: {
      '.Label': {
        fontWeight: '500',
        marginBottom: '10px',
        // fontFamily: 'Poppins'
      },
      '.Input': {
        borderRadius: '12px',
        padding: '1rem',
        // fontFamily: 'Poppins'
      }
    }
  };
  const options = {
    clientSecret: paymentDetail?.paymentIntent,
    appearance,
  };

  return (
    <div className={containerOne}>
      {/* Back Button */}
      <div className="sticky top-0 bg-white z-10 mb-4">
        <button
          onClick={() => navigate(-1)}
          className="p-2 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors"
        >
          <img src={arrowBlack} alt="back" className="w-5 h-5" />
        </button>
      </div>

      {paymentDetail?.paymentIntent && (
        <Elements options={options} stripe={stripePromise}>
          <PaymentForm />
        </Elements>
      )}
    </div>
  );
}